import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-exchange-confirm-modal',
  templateUrl: './exchange-confirm-modal.component.html',
  styleUrls: ['./exchange-confirm-modal.component.scss']
})
export class ExchangeConfirmModalComponent implements OnInit {
  @Input() isShowModal = false;
  @Input() isSubmitted = false;
  @Input() confirmText = 'MILEAGE.MD_EXCHANGE_CONFIRM_MESSAGE';

  @Input() labelApply = 'MILEAGE.MD_EXCHANGE_BTN_APPLY';
  @Input() labelCancel = 'MILEAGE.MD_EXCHANGE_BTN_CLOSE';
  @Output() closeModal = new EventEmitter<boolean>();
  @Output() exchangePoints = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
  }

  onCloseModal(): void {
    this.closeModal.emit(false);
  }

  onApplyExchange(): void {
    this.exchangePoints.emit();
  }

}
